/**
 * 高级检索
 * 2017-12-04
 * Bai.Zhiming
 */
"use strict";
angular.module("resAdvancedSearchModule", [
    "resAdvancedSearchRouterModule" //高级检索路由
]).
controller("resAdvancedSearchCtrl", ["$scope", "trsHttpService", "$q", "$state","$validation","modalDialog", function($scope, trsHttpService, $q, $state, $validationProvider,modalDialog) {
    initStatus();
    initData();
    /**
     * [initStatus description] 初始化数据
     * @return {[type]} [description]
     */
    function initStatus() {
        $scope.page = { //分页参数
            pageNum: 1, //分页页数
            pageSize: 10, //单页数量
        };
        $scope.pageTwo = { //渠道栏目
            CURRPAGE: 1, //页号
            PAGESIZE: 20, //页面数据单次显示数量
        };
        $scope.ejectData = { //弹出框数据
            positionData: { //位置信息
                data: [{
                    name: '位于任何位置',
                    value: 'full'
                }, {
                    name: '位于文章标题',
                    value: 'title'
                }, {
                    name: '位于文章正文',
                    value: 'context'
                }, ],
                value: { //位置信息值
                    name: '位于任何位置',
                    value: 'full'
                }
            },
            postedMedia: { //发布媒体
                data: [{
                    name: '全部媒体',
                    value: '0'
                }, {
                    name: '按渠道类型',
                    value: '1'
                }, {
                    name: '按渠道栏目',
                    value: '2'
                }, ],
                value: { //位置信息值
                    name: '全部媒体',
                    value: 'full'
                },
                tableGet: [ //渠道栏目标题
                    {
                        name: '新华社',
                        value: 'xhsg'
                    }, {
                        name: '数字报',
                        value: 'szb'
                    }, {
                        name: '网站',
                        value: 'wz'
                    }, {
                        name: '客户端',
                        value: 'app'
                    }, {
                        name: '微信',
                        value: 'wx'
                    }, {
                        name: '集团成品',
                        value: 'jtcpg'
                    },
                ],
                tableData: [ //渠道栏目数据
                ],
            },
            themeSearch: { //主题类型
                data: [],
                value: {
                    id: "zyzxfield_000",
                    name: "全部",
                    dictNum: "000",
                    orderNum: "1"
                }
            },
            selectShow: { //发布媒体显示对象切换
                showMediaOne: false,
                showMediaTwo: false
            },
        };
        $scope.timeData = { //时间参数
        };
        $scope.checkData = { //多选框可选择数
            content: [ //内容属性选框参数值
                {
                    name: '只看原创',
                    value: 'original'
                }, {
                    name: '只看头版（数字报）',
                    value: 'headline'
                }, {
                    name: '只看10W+（微信）',
                    value: 'hot'
                },
            ],
            include: [ //包含内容属性选框值
                {
                    name: '图片',
                    value: 'picture'
                }, {
                    name: '音视频',
                    value: 'media'
                },
            ],
            Channel: [ //渠道类型选框值
                {
                    name: '新华社',
                    value: 'all',
                    ditName: 'xhsg'
                }, {
                    name: '网站',
                    value: 'all',
                    ditName: 'wz'
                }, {
                    name: '微信',
                    value: 'all',
                    ditName: 'wx'
                }, {
                    name: '数字报',
                    value: 'all',
                    ditName: 'szb'
                }, {
                    name: '客户端',
                    value: 'all',
                    ditName: 'app'
                }, {
                    name: '集团成品',
                    value: 'all',
                    ditName: 'jtcpg'
                },
            ]
        };
        $scope.selectCheckData = { //判断多选框是否可被勾选
            selectContent: [], //内容属性选框
            selectInclude: [], //包含内容属性选框
            selectChannel: [], //渠道类型选框
            selectColumn: { //渠道栏目选框
                xhsg: [], //新华社
                szb: [], //数字报
                wz: [], //网站
                app: [], //客户端
                wx: [], //微信
                jtcpg: [], //集团成品
            },
            selection: [], //渠道栏目已选
        };
        $scope.areaAll = [ //地域的级联数组
        ];
        $scope.modelParameter = { //设置一系列ng-model参数默认值
            allRetrieva: '', //包含全部检索词
            exactSearch: '',
            keyWords: '',
            notKeyWords: '',
            ManuscriptId: '',
            // lssuer: ''
            author: '',
            numMin: 0,
            numMax: '',
            accurateWords: '',
            accurateLabel: '',
        };
        $scope.params = { //请求参数
            typeid: 'zyzx',
            serviceid: 'iwo',
            modelid: 'fullTableSearch',
            pageNum: $scope.page.pageNum,
            pageSize: $scope.page.pageSize,
            order: '-DOCPUBTIME', //默认按时间倒叙排序
            keywords: {
                search_relation: "0", //暂保留字段
                search_type: 'document', //暂保留字段
                search_range: 'full', //出现检索词位置
                source_range: [{
                    channelname: 'all',
                    sourcename: 'all'
                }]
            },
        };
        $scope.paramsTwo = { //渠道栏目参数
            typeid: 'zyzx',
            serviceid: 'iwo',
            modelid: 'subscription',
            channelName: '',
            pageNum: $scope.pageTwo.PAGECOUNT,
            pageSize: $scope.pageTwo.PAGESIZE,
        };
        $scope.tabTo = 0; //切换tab标签页判断条件
        $scope.mediaLm = []; //渠道栏目多选框切换值
        $scope.quDao = false; //判断是否选
        $scope.resultePage = [];
        $scope.in = ''; //
        $scope.vl = ''; //table页切换类型
        $scope.searchCl = ''; //渠道栏目搜索框默认值
        $scope.whetherJudge = false; //判断是否需要清除发布媒体双全选
    }
    /**
     * [initData description] 初始化状态
     * @return {[type]} [description]
     */
    function initData() {
        themeData();
    }
    /**
     * [getSearch description] 点击搜索
     * @return {[type]} [description]
     */
    $scope.getSearch = function () {
        $scope.searchForm.$pending = {};
        $validationProvider
            .validate($scope.searchForm)
            .success(function () { searchData() })
            .error(function () {
                modalDialog.alertType('搜索失败', '标红的填写项不允许包含特殊字符', 'warning', false);
        })
    };
    /**
     * [choiceClose description] 下拉框选择
     * @return {[type]} [description]
     */
    $scope.choiceClose = function() {
        switch (arguments[0]) {
            case 'search_range': //文字位置
                $scope.params.keywords.search_range = arguments[1].value;
                break;
            case 'source_range': //发布媒体
                // $scope.params.keywords.source_range = arguments[1].value;
                $scope.ejectData.selectShow.showMediaOne = false;
                $scope.ejectData.selectShow.showMediaTwo = false;
                if (arguments[1].value == '1') {
                    $scope.ejectData.selectShow.showMediaOne = true;
                } else if (arguments[1].value == '2') {
                    $scope.ejectData.selectShow.showMediaTwo = true;
                    $scope.tableToggle(0, 'xhsg'); //点开就开始请求多选数据，默认新华社
                }
                break;
            case 'topic':
                if (arguments[1].dictNum == '000') {
                    delete $scope.params.keywords.topic;
                } else {
                    $scope.params.keywords.topic = arguments[1].id;
                }
                break;
            default:
        }
    };
    /**
     * [getTimeDate description] 选择时间
     * @return {[type]} [description]
     */
    $scope.getTimeDate = function() {
        var et = $scope.timeData.fromdate.replace(new RegExp("-", "gm"), "/");
        var st = $scope.timeData.untildate.replace(new RegExp("-", "gm"), "/");
        regTrue(et) ? $scope.params.keywords.time_range = et + ';' + st : delete $scope.params.keywords.time_range;
    };
    /**
     * [selectItem description] 多选框选择
     * @param  {[type]} item [description]
     * @return {[type]}      [description]
     */
    $scope.selectItem = function(item, key, diff) {
        var index = '';
        // if (key === 1) { //判定内容属性多选勾不勾选
        index = key.indexOf(item);
        if (index >= 0)
            key.splice(index, 1);
        else
            key.push(item);
    };
    /**
     * [tableToggle description] 渠道栏目table切换请求
     * @return {[type]} [description]
     */
    $scope.tableToggle = function(index, value) {
        $scope.tabTo = index; //切换下边框
        if ($scope.paramsTwo.channelName != value) {
            $scope.paramsTwo.pageNum = 1;
            $scope.pageTwo.CURRPAGE = 1;
        }
        $scope.paramsTwo.channelName = value; //切换样式
        $scope.vl = value;
        // $scope.pageTwo.PAGECOUNT = 1;
        trsHttpService.httpServer(trsHttpService.getBigDataRootUrl(), $scope.paramsTwo, "post").then(function(data) {
            // 总数据
            $scope.ejectData.postedMedia.tableData = data.content;
            $scope.ITEMCOUNT = data.summary_info.ITEMCOUNT;
            if ($scope.selectCheckData.selection.length > 0) {
                for (var i in $scope.selectCheckData.selection) { //已选
                    for (var j in $scope.ejectData.postedMedia.tableData) { //新刷数据
                        if ($scope.selectCheckData.selection[i].HYBASEID == $scope.ejectData.postedMedia.tableData[j].HYBASEID) {
                            $scope.mediaLm.push($scope.ejectData.postedMedia.tableData[j]);
                        }
                    }
                }
            }

        });
    };
    /**
     * [funciton description] 渠道栏目点x删除
     * @return {[type]} [description]
     */
    $scope.sweat = function(key) {
        $scope.selectCheckData.selection.splice($scope.selectCheckData.selection.indexOf(key), 1);
        $scope.mediaLm.splice($scope.mediaLm.indexOf(key), 1);
        for (var i in $scope.selectCheckData.selection) {
            if ($scope.selectCheckData.selection[i].HYBASEID == key.HYBASEID) {
                $scope.selectCheckData.selection.splice(i, 1);
            }
        }
        for (var k in $scope.mediaLm) {
            if ($scope.mediaLm[k].HYBASEID == key.HYBASEID) {
                $scope.mediaLm.splice(k, 1);
            }
        }
        var lu = $scope.selectCheckData.selectColumn[key.SECTION].indexOf(key);
        lu != -1 && $scope.selectCheckData.selectColumn[key.SECTION].splice(lu, 1);
        $scope.selectCheckData.selection.indexOf(key) != -1 && $scope.selectCheckData.selection.splice($scope.selectCheckData.selection.indexOf(key), 1);
    };
    /**
     * [funciton description] 渠道栏目搜索
     * @return {[type]} [description]
     */
    $scope.searchColumn = function(key) {
        regTrue(key) ? $scope.paramsTwo.keyword = key : delete $scope.paramsTwo.keyword;
        trsHttpService.httpServer(trsHttpService.getBigDataRootUrl(), $scope.paramsTwo, "post").then(function(data) {
            // 总数据
            $scope.ejectData.postedMedia.tableData = data.content;
            $scope.ITEMCOUNT = data.summary_info.ITEMCOUNT;
        });
    };
    /**
     * [arrIndexOf description] 对象数组查找对象
     * @return 所找对象下标
     * */
    $scope.arrIndexOf = function(arr, obj) {
        let result = -1;
        let item;
        if (arr.length > 0) {
            for (let i = 0; arr[i] != null; i++) {
                result = i;
                item = arr[i];
                for (let k in item) {
                    if (item[k] != obj[k]) {
                        result = -1;
                        break;
                    } else if (k == Object.getOwnPropertyNames(item)[Object.getOwnPropertyNames(item).length - 1]) {
                        return result;
                    }
                }
                if (i == arr.length - 1) {
                    return result;
                }
            }
        } else {
            return -1;
        }
    };

    /**
     *[selectStatus description] 多选框选中状态判断
     *@return boolean
     */
    $scope.selectStatus = function(item) {
        delete item.$$hashKey;
        return $scope.arrIndexOf($scope.mediaLm, item) < 0 ? false : true;
    };
    /**
     * [mediaSelect description] 发布媒体专用选框
     * @return {[type]} [description]
     */
    $scope.mediaSelect = function(item, key, dif) {
        var index = $scope.arrIndexOf(key, item);
        if (index >= 0) { //取消勾选 selectAll
            key.splice(index, 1);
            if (dif == 2) { //渠道栏目
                // CHANNELNAME 替换为 SECTION
                var lu = $scope.selectCheckData.selectColumn[item.SECTION].indexOf(item);
                lu != -1 && $scope.selectCheckData.selectColumn[item.SECTION].splice(lu, 1);
                $scope.arrIndexOf($scope.selectCheckData.selection, item) != -1 && $scope.selectCheckData.selection.splice($scope.arrIndexOf($scope.selectCheckData.selection, item), 1);
            }
        } else { //添加勾选
            key.push(item);
            if (dif == 2) { //对应渠道栏目
                $scope.selectCheckData.selectColumn[item.SECTION].push(item);
                $scope.selectCheckData.selection.push(item); //已选择
            }
        }
    };
    /**
     * [pageChanged description]分页-点击数字切换页
     * @return {[type]} [description]
     */
    $scope.pageChanged = function() {
        $scope.paramsTwo.pageNum = $scope.pageTwo.CURRPAGE;
        $scope.tableToggle($scope.tabTo, $scope.vl);
    };

    /**
     * [regTrue description] 检查非空
     * @param  {[type]} value [description]
     * @return {[type]}       [description]
     */
    function regTrue(value) {
        return /\S/.test(value);
    }

    /**
     * [arrayToString description] 数组转为字符串
     * @param  {[type]} array [description]
     * @return {[type]}       [description]
     */
    function arrayToString(array) {
        if (array.length > 0) {
            var stringArray = [];
            for (var i = 0; i < array.length; i++) {
                stringArray.push(array[i].name);
            }
            return stringArray.join(" ");
        }
    }
    /**
     * 
     * [paramsJudgment description] 判断是否传递该参数
     * @return {[type]} [description]
     */
    function paramsJudgment() {
        //包含全部检索词
        $scope.modelParameter.allRetrieva.length > 0 ? $scope.params.keywords.keyword_spilt = arrayToString($scope.modelParameter.allRetrieva) : delete $scope.params.keywords.keyword_spilt;
        // regTrue($scope.modelParameter.allRetrieva) ? $scope.params.keywords.keyword_spilt = $scope.modelParameter.allRetrieva : delete $scope.params.keywords.keyword_spilt;
        // //包含精确检索词
        $scope.modelParameter.exactSearch.length > 0 ? $scope.params.keywords.keyword_and = arrayToString($scope.modelParameter.exactSearch) : delete $scope.params.keywords.keyword_and;
        // regTrue($scope.modelParameter.exactSearch) ? $scope.params.keywords.keyword_and = $scope.modelParameter.exactSearch : delete $scope.params.keywords.keyword_and;
        // //包含至少一个检索词
        $scope.modelParameter.keyWords.length > 0 ? $scope.params.keywords.keyword_or = arrayToString($scope.modelParameter.keyWords) : delete $scope.params.keywords.keyword_or;
        // regTrue($scope.modelParameter.keyWords) ? $scope.params.keywords.keyword_or = $scope.modelParameter.keyWords : delete $scope.params.keywords.keyword_or;
        // //不包含检索词
        $scope.modelParameter.notKeyWords.length > 0 ? $scope.params.keywords.keyword_not = arrayToString($scope.modelParameter.notKeyWords) : delete $scope.params.keywords.keyword_not;
        // regTrue($scope.modelParameter.notKeyWords) ? $scope.params.keywords.keyword_not = $scope.modelParameter.notKeyWords : delete $scope.params.keywords.keyword_not;
        // //稿件ID
        regTrue($scope.modelParameter.ManuscriptId) ? $scope.params.keywords.guid = $scope.modelParameter.ManuscriptId : delete $scope.params.keywords.guid;
        // //签发人    
        //regTrue($scope.modelParameter.lssuer) ? $scope.params.keywords.signer = $scope.modelParameter.lssuer : delete $scope.params.keywords.signer;
        // //作者
        regTrue($scope.modelParameter.author) ? $scope.params.keywords.author = $scope.modelParameter.author : delete $scope.params.keywords.author;
        // //包含精确关键词
        $scope.modelParameter.accurateWords.length > 0 ? $scope.params.keywords.exactkeywords = arrayToString($scope.modelParameter.accurateWords) : delete $scope.params.keywords.exactkeywords;
        // regTrue($scope.modelParameter.accurateWords) ? $scope.params.keywords.exactkeywords = $scope.modelParameter.accurateWords : delete $scope.params.keywords.exactkeywords;
        // //包含精确标签
        $scope.modelParameter.accurateLabel.length > 0 ? $scope.params.keywords.exacttag = arrayToString($scope.modelParameter.accurateLabel) : delete $scope.params.keywords.exacttag;
        // regTrue($scope.modelParameter.accurateLabel) ? $scope.params.keywords.exacttag = $scope.modelParameter.accurateLabel : delete $scope.params.keywords.exacttag;
        // //字数
        !regTrue($scope.modelParameter.numMin) && !regTrue($scope.modelParameter.numMax) ? delete $scope.params.keywords.txs_rannge : $scope.params.keywords.txs_rannge = (regTrue($scope.modelParameter.numMin) ? $scope.modelParameter.numMin : '*') + ';' + (regTrue($scope.modelParameter.numMax) ? $scope.modelParameter.numMax : '*');
        // //内容属性
        $scope.params.keywords.content_attribute = [{
            original: "0",
            headline: "0",
            hot: "0"
        }];
        for (var i in $scope.selectCheckData.selectContent) {
            if ($scope.selectCheckData.selectContent[i].value == "original") {
                $scope.params.keywords.content_attribute[0].original = "1";
                // original: 0,
                // headline: 0,
                // hot: 0
            } else if ($scope.selectCheckData.selectContent[i].value == 'headline') {
                $scope.params.keywords.content_attribute[0].headline = "1";
            } else {
                $scope.params.keywords.content_attribute[0].hot = "1";
            }
        }

        //是否包含以下内容
        $scope.params.keywords.contains = [{
            picture: "0",
            meidia: "0"
        }];
        for (var i in $scope.selectCheckData.selectInclude) {
            if ($scope.selectCheckData.selectInclude[i].value == "picture") {
                $scope.params.keywords.contains[0].picture = "1";
            } else if ($scope.selectCheckData.selectInclude[i].value == 'media') {
                $scope.params.keywords.contains[0].meidia = "1";
            }
        }
        //      $scope.selectCheckData = { //判断多选框是否可被勾选
        //     selectContent: [], //内容属性选框
        //     selectInclude: [], //包含内容属性选框
        //     selectChannel: [], //渠道类型选框
        //     selectColumn: { //渠道栏目选框
        //         xhsg: [], //新华社
        //         szb: [], //数字报
        //         wz: [], //网站
        //         app: [], //客户端
        //         wx: [], //微信
        //         jtcpg: [], //集团成品
        //     },
        //     selection: [], //渠道栏目已选
        // };
        //判断渠道类型和渠道栏目
        //初始化
        $scope.params.keywords.source_range = [{
            channelname: 'all',
            sourcename: 'all'
        }];
        var addType = [];
        var typeSmarqueeCopy = angular.copy($scope.selectCheckData.selectColumn);
        //抽离类型集合(有勾选)保存在addType做渠道栏目去除
        if ($scope.selectCheckData.selectChannel.length > 0) { //渠道类型有勾选的情况
            $scope.whetherJudge = true;
            for (var i in $scope.selectCheckData.selectChannel) {
                $scope.params.keywords.source_range.push({
                    channelname: 'all',
                    sourcename: $scope.selectCheckData.selectChannel[i].ditName
                });
                //删除类型已有的勾选
                delete typeSmarqueeCopy[$scope.selectCheckData.selectChannel[i].ditName];
            }
            //操作渠道栏目有选的
            for (var j in typeSmarqueeCopy) { //CHANNELNAME=app HYBASEID="ranknature_002"
                if (typeSmarqueeCopy[j].length > 0) { //有勾选的拿过来处理
                    var takeOne = '';
                    for (var k in typeSmarqueeCopy[j]) { //取出
                        takeOne += typeSmarqueeCopy[j][k].HYBASEID + ',';
                        if (k == typeSmarqueeCopy[j].length - 1) {
                            takeOne = takeOne.substring(0, takeOne.length - 1);
                            $scope.params.keywords.source_range.push({
                                channelname: takeOne,
                                sourcename: typeSmarqueeCopy[j][k].SECTION
                            });
                        }
                    }
                }
            }
        } else if ($scope.selectCheckData.selectChannel.length == 0) { //类型无勾选
            for (var i in $scope.selectCheckData.selectColumn) {
                var takeTwo = '';
                if ($scope.selectCheckData.selectColumn[i].length > 0) {
                    $scope.whetherJudge = true;
                    for (var j in $scope.selectCheckData.selectColumn[i]) {
                        takeTwo += typeSmarqueeCopy[i][j].HYBASEID + ',';
                        if (j == typeSmarqueeCopy[i].length - 1) {
                            takeTwo = takeTwo.substring(0, takeTwo.length - 1);
                            $scope.params.keywords.source_range.push({
                                channelname: takeTwo,
                                sourcename: typeSmarqueeCopy[i][j].SECTION
                            });
                        }
                    }
                }
            }
        }
        $scope.whetherJudge == true && $scope.params.keywords.source_range.splice(0, 1);
    }
    /**
     * [searchData description] 请求数据跳转高级搜索结果页
     * @return {[type]} [description]
     */
    function searchData() {
        paramsJudgment();
        var params = angular.copy($scope.params);
        if ($scope.ejectData.selectShow.showMediaOne) {
            params.keywords.showMedia = 1;
            params.keywords.selectChannel = $scope.selectCheckData.selectChannel;

        } else if ($scope.ejectData.selectShow.showMediaTwo) {
            params.keywords.showMedia = 2;
            params.keywords.selection = $scope.selectCheckData.selection;
            // params.marqueeSection = $scope.mediaLm;
        } else {
            params.keywords.showMedia = 0;
        }
        if ($scope.params.keywords.area != undefined) {
            params.keywords.areaAll = $scope.areaAll;
        }
        var url = $state.href('seniorResults');
        window.open(url + "?rightsData=" + JSON.stringify(params));
    }
    /**
     * [modiaData description] 主题数据请求
     * @return {[type]} [description]
     */
    function themeData() {
        var params = {
            typeid: 'zyzx',
            serviceid: 'subscript',
            modelid: 'getAllFields'
        };
        $scope.loadingPromise = trsHttpService.httpServer(trsHttpService.getBigDataRootUrl(), params, 'post').then(function(data) {
            for (var i in data) {
                data[i].name = data[i].dictName;
                delete data[i].dictName;
            }
            data.unshift($scope.ejectData.themeSearch.value);
            $scope.ejectData.themeSearch.data = $scope.ejectData.themeSearch.data.concat(data);
            $scope.status.themeList = data;
        });
    }
    /**
     * [showSelectedArea description] 地域选中
     * @param  {[type]} node [description]
     * @return {[type]}      [description]
     */
    $scope.showSelectedArea = function(node) {
        var deffer = $q.defer();
        var params = {
            typeid: 'zyzx',
            serviceid: 'navigation',
            modelid: 'getArea',
        };
        if (node.id == undefined) {
            params.parent_id = '-1';
        } else {
            params.parent_id = node.id;
        }
        trsHttpService.httpServer(trsHttpService.getBigDataRootUrl(), params, 'get').then(function(data) {
            if (data.length > 2) {
                deffer.resolve(data);

            } else
                deffer.resolve(data[0].CHILDREN);
        });
        return deffer.promise;
    };
    /**
     * [searchWithArea description] 根据地域信息筛选稿件
     * @return {[type]} [description]
     */
    $scope.searchWithArea = function() {
        $scope.params.keywords.area = $scope.areaAll[0][$scope.areaAll[0].length - 1].id;
    };

}]);
